import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Upload from '../../upload/Upload';
import actions from '@/redux/action';
import { request } from '@/api/request';
import moment from 'moment';
import sentGAEvent from '@/ga';
import Utils from '@/utils';
import TipsModal from '@/components/common/tipModal/TipsModal';
import AudioWorkContentFunction from './children/audioWorkContentFunction/AudioWorkContentFunction';
import AudioWorkFooterFunction from './children/audioWorkFooterFunction/AudioWorkFooterFunction';
import AudioWorkFinishFunction from './children/audioWorkFinishFunction/AudioWorkFinishFunction';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';

import Process from '@/components/common/process/Process';
import '@/assets/audioAddMusic.less';

class AudioAddMusicWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioAccept: '.wav,.mp3,.m4a,.aac,.ogg,.mp4,.mov,.webm',
      audioWorkStatus: '',
      audioJoinerAfter: {},
      warningInfo: false,
      warningInfoText: '',
      warningInfoObj: {},
    };
    this.cancelAddMusic = false;
  }

  handlePurchaseModalObjChange = (purchaseModalObj) => {
    console.log(purchaseModalObj);
    this.props.onPurchaseModalObjChange(purchaseModalObj);
  };

  handleSubmit = async (format) => {
    let audioItemSizes = '';
    this.props.audioAddMusicList.forEach((item) => {
      audioItemSizes =
        audioItemSizes + '_' + (item.fileObj.size / 1024).toFixed(2) + 'kb';
    });
    sentGAEvent({
      category: 'add_music_output',
      action: 'add_music_export',
      label:
        this.props.audioAddMusicList.length + '_' + format + audioItemSizes,
    });

    let flag = Utils.handleVideoEditorTimes('33AM');
    if (flag) {
      return false;
    }

    this.cancelAddMusic = false;
    this.setState({ format, submitting: true });
    const audioAddMusicList = [...this.props.audioAddMusicList];
    const unUploadAudioList = audioAddMusicList.filter(
      (item) => item.status !== 'uploaded'
    );
    this.props.onProcessStepChange(unUploadAudioList.length * 2 + 1);
    for (let i = 0; i < unUploadAudioList.length; i++) {
      if (this.cancelAddMusic) {
        this.handleSubmitFail('cancel');
        return false;
      }
      let audioAddMusicItem = unUploadAudioList[i];
      let fileResponse;
      try {
        fileResponse = await this.requestUploadAudioFile(
          audioAddMusicItem.fileObj
        );
      } catch (error) {
        if (error !== 'cancel') {
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerFail',
            label: error + '_none_none_' + this.props.tokenId + '_none_none',
          });
        }
        this.handleSubmitFail(error);
        return false;
      }
      if (this.cancelAddMusic) {
        this.handleSubmitFail('cancel');
        return false;
      }
      console.log('请求上传完毕');
      if (fileResponse.code === 200) {
        sentGAEvent({
          category: 'UploadSuccess',
          action: '33AM_UploadSuccess',
          label: 'Null',
        });
        if (fileResponse.data.result.number) {
          const fileResponseNumber = fileResponse.data.result.number;
          const fileResponseUrl = fileResponse.data.response_file[0];
          console.log('获取瑾度条上');
          try {
            await Utils.getProgress(fileResponseNumber, false);
          } catch (error) {
            if (error !== 'cancel') {
              sentGAEvent({
                category: 'Upload',
                action: 'LocalSerFail',
                label: 'uploadAudio' + '_200_200_' + error,
              });
            }
            this.handleSubmitFail(error);
            return false;
          }
          audioAddMusicItem.videofileurl = fileResponseUrl;
          audioAddMusicItem.status = 'uploaded';
          this.handleAudioItemChange(audioAddMusicItem);
        }
      } else {
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerFail',
          label:
            'uploadAudio' +
            '_200_' +
            fileResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            fileResponse.msg,
        });
        this.handleSubmitFail();
        if (fileResponse.code === 401) {
          Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
          let hostName = window.location.hostname;
          Cookies.remove('access_token', {
            domain: hostName.substring(
              window.location.hostname.indexOf('.'),
              hostName.length
            ),
          });
          Cookies.remove('access_token_expires_in', {
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          window.location.replace(
            `${accountList.get('login')}?redirect=${window.location.href}`
          );
        }
        return false;
      }
    }
    if (this.cancelAddMusic) {
      this.handleSubmitFail('cancel');
      return false;
    }
    let joinerResponse;
    try {
      joinerResponse = await this.requstAddMusic(
        format,
        this.getFilesToRequest(audioAddMusicList)
      );
    } catch (error) {
      if (error !== 'cancel') {
        sentGAEvent({
          category: 'add_music_output',
          action: 'add_music_output_failed',
          label: error + '_none_none_' + this.props.tokenId + '_none_none',
        });
        sentGAEvent({
          category: 'add_music_output',
          action: 'add_music_output_failed',
          label: audioAddMusicList.length + '_' + format + audioItemSizes,
        });
      }
      this.handleSubmitFail(error);
      return false;
    }
    if (this.cancelAddMusic) {
      this.handleSubmitFail('cancel');
      return false;
    }
    if (joinerResponse.code === 200) {
      sentGAEvent({
        category: 'ProcessStart',
        action: '33AM_ProcessStart',
        label: 'Null',
      });
      if (joinerResponse.data.result.number) {
        const joinerResponseNumber = joinerResponse.data.result.number;
        let progressResponse;
        try {
          progressResponse = await Utils.getProgress(
            joinerResponseNumber,
            false
          );
          sentGAEvent({
            category: 'ProcessSuccess',
            action: '33AM_ProcessSuccess',
            label: 'Null',
          });
        } catch (error) {
          if (error !== 'cancel') {
            sentGAEvent({
              category: 'add_music_output',
              action: 'add_music_output_failed',
              label: 'mixAudios' + '_200_200_' + error,
            });
            sentGAEvent({
              category: 'add_music_output',
              action: 'add_music_output_failed',
              label: audioAddMusicList.length + '_' + format + audioItemSizes,
            });
          }
          this.handleSubmitFail(error);
          return false;
        }
        const audioJoinerAfter = {
          name: 'HitPaw Add Music Audio.' + format,
          size: parseFloat(progressResponse.info[0].size),
          downloadurl: progressResponse.info[0].url,
          duration: moment('00:00:00', 'mm:ss:SS')
            .add(
              parseFloat(parseFloat(progressResponse.info[0].duration)),
              'seconds'
            )
            .format('mm:ss:SS')
            .replace(/:([^:]*)$/, '.$1'),
        };
        sentGAEvent({
          category: 'add_music_output',
          action: 'add_music_output_success',
          label:
            '1_' + format + (audioJoinerAfter.size / 1024).toFixed(2) + 'kb',
        });
        this.setState({
          submitting: false,
          audioWorkStatus: 'success',
          audioJoinerAfter,
        });
        this.props.onProcessPercentChange(0);
        this.props.onProcessStepChange(0);
        this.props.onUploadPercentChange(0);
      }
    } else {
      if (joinerResponse.code === 402102) {
        sentGAEvent({
          category: 'UpgradePrompShow',
          action: '33AM_UpgradePrompShow',
        });
        this.props.onPurchaseModalObjChange({
          visible: true,
          type: 'videoEditorTimesMoreThanLimit',
        });
        this.handleSubmitFail('cancel');
      } else {
        this.handleSubmitFail();
      }
      sentGAEvent({
        category: 'add_music_output',
        action: 'add_music_output_failed',
        label:
          'mixAudios_' +
          joinerResponse.code +
          '_none_' +
          this.props.tokenId +
          '_none_' +
          joinerResponse.msg,
      });
      sentGAEvent({
        category: 'add_music_output',
        action: 'add_music_output_failed',
        label: audioAddMusicList.length + '_' + format + audioItemSizes,
      });

      return false;
    }
  };

  handleSubmitFail = (error) => {
    if (error !== 'cancel') {
      this.setState({
        audioWorkStatus: 'failed',
      });
    }
    this.setState({ submitting: false });
    this.props.onProcessPercentChange(0);
    this.props.onProcessStepChange(0);
    this.props.onUploadPercentChange(0);
  };

  getFilesToRequest = (audioAddMusicList) => {
    let files = [];
    let startTime =
      Utils.getSeconds(audioAddMusicList[0].start) +
      audioAddMusicList[0].dragXTime;
    console.log(startTime);
    audioAddMusicList.forEach((item) => {
      let itemStartTime = Utils.getSeconds(item.start) + item.dragXTime;
      if (itemStartTime < startTime) {
        startTime = itemStartTime;
      }
    });
    console.log(startTime);
    audioAddMusicList.forEach((item, index) => {
      let itemStartTime = Utils.getSeconds(item.start) + item.dragXTime;
      let file = {
        url: item.videofileurl,
        from: '00:' + item.start,
        to: '00:' + item.end,
        volume: (item.volume * 100).toFixed(0) * 1,
        delay: itemStartTime - startTime,
      };
      files.push(file);
    });
    console.log(files);
    return files;
  };

  requstAddMusic = (format, files) => {
    const formData = new FormData();
    formData.append('output_format', format);
    formData.append('file[]', JSON.stringify({ files: [...files] }));
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`mixAudios`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  requestUploadAudioFile = (file) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    sentGAEvent({
      category: 'UploadStart',
      action: '33AM_UploadStart',
      label: 'Null',
    });
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadAudio`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = parseInt((event.loaded / event.total) * 100);
          if (this.props.uploadPercent < 100) {
            this.props.onUploadPercentChange(percent);
          } else {
            this.props.onUploadPercentChange(
              percent +
                (this.props.uploadPercent - (this.props.uploadPercent % 100))
            );
          }
        }
      };
      xhr.onerror = () => {
        reject('uploadVideo_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        console.log('ddddddddddd', JSON.parse(xhr.response));
        resolve(JSON.parse(xhr.response));
        console.log('xxxxxxx');
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  addFileCallBack = (audioAddMusicItem) => {
    const audioAddMusicList = [...this.props.audioAddMusicList];
    console.log('audioAddMusicItem', audioAddMusicList);
    audioAddMusicItem.start = '00:00.00';
    audioAddMusicItem.end = audioAddMusicItem.duration;
    audioAddMusicItem.volume = 1;
    audioAddMusicItem.startPercent = 0;
    audioAddMusicItem.isLarge = true;
    audioAddMusicItem.dragX = 0;
    audioAddMusicItem.dragXTime = 0;
    audioAddMusicItem.wavesurferContRef = React.createRef();
    if (audioAddMusicList.length) {
      if (
        Utils.getSeconds(audioAddMusicList[0].duration) >
        Utils.getSeconds(audioAddMusicItem.duration)
      ) {
        audioAddMusicList[0].isLarge = true;
        audioAddMusicItem.isLarge = false;
      } else if (
        Utils.getSeconds(audioAddMusicList[0].duration) <
        Utils.getSeconds(audioAddMusicItem.duration)
      ) {
        audioAddMusicList[0].isLarge = false;
        audioAddMusicItem.isLarge = true;
      } else {
        audioAddMusicList[0].isLarge = true;
        audioAddMusicItem.isLarge = true;
      }
    }
    audioAddMusicList.push(audioAddMusicItem);
    this.props.onAudioAddMusicListChange(audioAddMusicList);
  };

  handleAudioItemChange = (audioAddMusicItem, relativeAudioObj) => {
    const audioAddMusicList = [...this.props.audioAddMusicList];
    for (let i = 0; i < audioAddMusicList.length; i++) {
      if (audioAddMusicList[i].guid === audioAddMusicItem.guid) {
        if (i === 0 && audioAddMusicList.length > 1) {
          audioAddMusicList[i + 1].fadeIn = audioAddMusicItem.fadeOut;
        }
        audioAddMusicList[i] = { ...audioAddMusicItem };
        break;
      }
    }
    if (relativeAudioObj) {
      audioAddMusicList[relativeAudioObj.index] = {
        ...relativeAudioObj.audioAddMusicItem,
      };
    }
    this.props.onAudioAddMusicListChange(audioAddMusicList);
  };

  cancelProcessCallBack = () => {
    this.setState({
      submitting: false,
    });
    this.cancelAddMusic = true;
  };

  handleWarningObj = ({ warningInfo, warningInfoText, warningInfoObj }) => {
    this.setState({
      warningInfo,
      warningInfoText,
      warningInfoObj,
    });
  };

  render() {
    const { t } = this.props;

    return (
      <div className='audio-work-cont'>
        {this.state.audioWorkStatus !== 'failed' &&
        this.state.audioWorkStatus !== 'success' ? (
          <div>
            {this.props.audioAddMusicList.length === 0 ? (
              <div>
                <h1 className='container'>
                  {t('HitPaw Add Music to Audio Online')}
                </h1>
                <p className='container sub-title'>
                  {t('Add BGM to Audio without any difficulties.')}
                </p>
                <Upload
                  visible={this.props.audioAddMusicList.length === 0}
                  accept={this.state.audioAccept}
                  isPreloadBlob
                  addFileCallBack={this.addFileCallBack}
                  uploadMaxCount={2}
                />
              </div>
            ) : null}

            {this.props.audioAddMusicList.length && !this.state.submitting ? (
              <div className='workplace'>
                <AudioWorkContentFunction
                  accept={this.state.audioAccept}
                  audioAddMusicList={this.props.audioAddMusicList}
                  onAudioAddMusicListChange={
                    this.props.onAudioAddMusicListChange
                  }
                  handleAudioItemChange={this.handleAudioItemChange}
                  handleWarningObj={this.handleWarningObj}
                  handlePurchaseModalObjChange={
                    this.handlePurchaseModalObjChange
                  }
                />
                <AudioWorkFooterFunction handleSubmit={this.handleSubmit} />
              </div>
            ) : null}
            {this.state.submitting ? (
              <div
                className='workplace'
                style={{ position: 'relative', minHeight: 400 }}
              >
                <Process
                  visible
                  theme='dark'
                  showProcessText
                  processText='Processing'
                  hideCancelText
                  cancelProcessCallBack={this.cancelProcessCallBack}
                  uploadNumber={this.props.audioAddMusicList.length}
                />
              </div>
            ) : null}
          </div>
        ) : null}
        {this.state.audioWorkStatus === 'failed' ||
        this.state.audioWorkStatus === 'success' ? (
          <AudioWorkFinishFunction
            status={this.state.audioWorkStatus}
            audioJoinerAfter={this.state.audioJoinerAfter}
            format={this.state.format}
            handleSubmitAgain={() => {
              this.setState(
                {
                  audioWorkStatus: 'ready',
                  submitting: true,
                },
                () => this.handleSubmit(this.state.format)
              );
            }}
          />
        ) : null}
        <TipsModal
          visible={this.state.warningInfo}
          onCancel={() => {
            this.setState({ warningInfo: false });
          }}
          content={this.state.warningInfoText}
          tipsObj={this.state.warningInfoObj}
          cancelBtnHandle={() => {
            this.setState({ warningInfo: false });
          }}
          hasDownload
        />
      </div>
    );
  }
}
const mapStateToPropos = (state) => ({
  audioAddMusicList: state.work.audioAddMusicList,
  tokenId: state.common.tokenId,
  uploadPercent: state.work.uploadPercent,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onAudioAddMusicListChange: (audioAddMusicList) =>
    dispatch(actions.onAudioAddMusicListChange(audioAddMusicList)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onPurchaseModalObjChange: (purchaseModalObj) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModalObj)),
});
export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['audioAddMusic'])(AudioAddMusicWork));
